import { useQuery, keepPreviousData } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";
import { ESTIMATE_KEYS } from "./queryKeys";
import type { PaginationParams, PaginationFilters } from "@rebuild/shared";

export function useGetAllEstimatesQuery() {
  return useQuery({
    queryKey: ESTIMATE_KEYS.all(),
    queryFn: async () => {
      const estimates = await estimateProvider.getEstimates();
      return estimates ?? [];
    },
  });
}

export function useGetDashboardEstimatesQuery(params: PaginationParams & PaginationFilters) {
  return useQuery({
    queryKey: ESTIMATE_KEYS.list(params),
    queryFn: () => estimateProvider.getEstimatesPaginated(params),
    placeholderData: keepPreviousData,
  });
}
